import { render, staticRenderFns } from "./ScreenAlert.vue?vue&type=template&id=a4aeee26&"
import script from "./ScreenAlert.vue?vue&type=script&lang=js&"
export * from "./ScreenAlert.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAlert.vue?vue&type=style&index=0&id=a4aeee26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports